<template>
  <div class="wrapper">
    <div class="add-new-button-wrapper" v-if="hasAddNewFlowPermission">
      <div
        class="add-new-button"
        @click="createNewFlow()"
        ref="plusButton"
        v-b-tooltip.hover.top
        title="Workflow erstellen"
      >
        Neu
        <i class="fas fa-chevron-down btn" @click.stop="toggleUploadFile"></i>
      </div>
      <div
        class="dropdown-list-open"
        :class="{ 'unset-zIndex': isLoading }"
        v-if="isUploadFileVisible"
      >
        <div
          class="filter dropdown upload"
          @click="toggleFileUploader()"
          v-click-outside="hideFileUploader"
        >
          <i class="fas fa-upload"></i> Aus Datei importieren
          <input
            ref="uploadBtn"
            style="display: none"
            type="file"
            accept="application/json"
            @change="importFlow"
          />
        </div>
      </div>
    </div>
    <div class="action-top-bar">
      <div class="action-top-bar-left">
        <div class="menu3-bar" v-show="isZoomVisible">
          <!-- filter by key / value -->
          <span>
            <ul class="list-item">
              <li class="item filter-option">
                <div class="key-filter">
                  <!-- Add new filter button -->
                  <div class="filter" v-click-outside="hideAddFilter">
                    <span class="filter-icon" @click="showAddFilter"></span>

                    <!-- Add new filter drop down-->
                    <div
                      class="filter dropdown add"
                      v-if="activeFilter != null && isAddFilterVisible"
                    >
                      <h2>Neuer Filter</h2>
                      <generalDropdown className="filter-dropdown">
                        <template v-slot:selectFilter>
                          <span class="line-clamp"
                            >{{ activeFilter.caption }}
                          </span>
                        </template>
                        <template v-slot:optionData>
                          <b-dropdown-item
                            v-for="item in dataSchema"
                            :key="item.label"
                            @click="addFilterCaption(item.name)"
                          >
                            {{ formatLabel(item.label) }}
                          </b-dropdown-item>
                        </template>
                      </generalDropdown>
                      <generalDropdown className="filter-dropdown">
                        <template v-slot:selectFilter>
                          <span class="line-clamp"
                            >{{ activeFilter.opperandLabel }}
                          </span>
                        </template>
                        <template v-slot:optionData>
                          <b-dropdown-item
                            v-for="operator in operatorOption"
                            :key="operator.label"
                            @click="
                              addFilterOpperand(
                                operator.opperand,
                                operator.label
                              )
                            "
                            v-show="showFilterOperator(operator)"
                          >
                            {{ operator.label }}
                          </b-dropdown-item>
                        </template>
                      </generalDropdown>
                      <input
                        v-if="!activeFilter.type || activeFilter.type == 'text'"
                        name="filter"
                        v-model="activeFilter.value"
                        :type="activeFilter.type"
                      />
                      <generalDropdown
                        className="filter-dropdown"
                        v-else-if="activeFilter.type == 'radio'"
                      >
                        <template v-slot:selectFilter>
                          <span class="line-clamp"
                            >{{ activeFilter.valueName }}
                          </span>
                        </template>
                        <template v-slot:optionData>
                          <b-dropdown-item
                            v-for="optionValue in getActiveFilterOption"
                            :key="optionValue.value || optionValue"
                            @click="
                              addFilterValue(
                                optionValue.value || optionValue,
                                optionValue.name || optionValue
                              )
                            "
                          >
                            {{ optionValue.name || optionValue }}
                          </b-dropdown-item>
                        </template>
                      </generalDropdown>
                      <hr />
                    </div>
                  </div>
                </div>
              </li>

              <li class="item">
                <div :class="{ active: searchActive }" class="search">
                  <span class="search-icon" @click="toggleSearch"></span>
                  <input ref="search" name="search" v-model="search" />
                </div>
              </li>
              <!-- <li class="item-mode-toggle">
            <i
              class="fas"
              :class="[!isGroupFlowListOpen ? 'fa-toggle-off' : 'fa-toggle-on']"
              @click="isGroupFlowListOpen = !isGroupFlowListOpen"
            ></i>
          </li> -->
              <!--  <li class="add-folder">
            <i
              class="fas fa-folder"
              @click="isAddGroupModalIsOpen = !isAddGroupModalIsOpen"
            ></i>
          </li> -->
            </ul>
          </span>
        </div>
      </div>
      <div class="action-top-bar-right">
        <NoFlows v-if="noData && !isLoading" />
        <div class="process-list-topbar" v-else>
          <div
            class="settings-button-wrapper"
            :class="{ 'pt-3': !hasAddNewFlowPermission }"
          >
            <div
              class="refresh"
              :class="{ rotation: isRefreshing }"
              @click="!isRefreshing && refreshTable()"
              v-b-tooltip.hover
              title="Aktualisieren"
            >
              <img src="../assets/img/refresh.svg" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Filter list -->
    <div class="filter-item-wrapper">
      <div class="filter-item" v-for="filter in filters" :key="filter.id">
        <span>{{ filter.caption }}</span>
        <i
          title="Bearbeiten"
          class="fas fa-caret-down"
          @click="showEditFilter(filter)"
        ></i>
        <i
          title="Löschen"
          class="fas fa-trash"
          @click="removeFilter(filter.id)"
        ></i>
        <!-- Edit filter drop down-->
        <div>
          <div
            v-if="
              activeFilter != null &&
              isEditFilterVisible &&
              activeFilter.id == filter.id
            "
            class="filter dropdown edit"
            v-click-outside="hideEditFilter"
          >
            <generalDropdown className="filter-dropdown">
              <template v-slot:selectFilter>
                <span class="line-clamp"
                  >{{ activeFilter.opperandLabel }}
                </span>
              </template>
              <template v-slot:optionData>
                <b-dropdown-item
                  v-for="operator in operatorOption"
                  :key="operator.label"
                  @click="addFilterOpperand(operator.opperand, operator.label)"
                  v-show="showFilterOperator(operator)"
                >
                  {{ operator.label }}
                </b-dropdown-item>
              </template>
            </generalDropdown>

            <input
              v-if="!activeFilter.type || activeFilter.type == 'text'"
              name="filter"
              v-model="activeFilter.value"
              :type="activeFilter.type"
            />
            <generalDropdown
              className="filter-dropdown"
              v-else-if="activeFilter.type == 'radio'"
            >
              <template v-slot:selectFilter>
                <span class="line-clamp">{{ activeFilter.valueName }} </span>
              </template>
              <template v-slot:optionData>
                <b-dropdown-item
                  v-for="optionValue in getActiveFilterOption"
                  :key="optionValue.value || optionValue"
                  @click="
                    addFilterValue(
                      optionValue.value || optionValue,
                      optionValue.name || optionValue
                    )
                  "
                >
                  {{ optionValue.name || optionValue }}
                </b-dropdown-item>
              </template>
            </generalDropdown>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!noData && !isLoading"
      class="process-list"
      :class="{ 'full-height': !hasAddNewFlowPermission }"
    >
      <div class="group-actions" v-if="showGroupAction">
        <div class="inner">
          <p>
            <span class="selected-items"> {{ selectedFlow.length }} </span>
            <span class="selected-items-label">Ausgewählte Einträge</span>
          </p>
          <ul class="toolbar">
            <li
              class="item share"
              @click="shareSelectedItems()"
              v-b-tooltip.hover
              title="Teilen"
            >
              <a class="link">share</a>
            </li>
            <li
              class="item download"
              @click="exportSelectedItems()"
              v-b-tooltip.hover
              title="Herunterladen"
            >
              <a class="link">download</a>
            </li>
            <li
              class="item delete"
              @click="removeSelectedItems()"
              v-b-tooltip.hover
              title="Löschen"
            >
              <a class="link">delete</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="progress-icon dark-color center" v-show="isLoading"></div>
      <div
        class="process-list-wrapper"
        v-show="!isLoading && isGroupFlowListOpen"
      >
        <div v-if="groups.length > 0">
          <div v-for="(group, idx) in groups" :key="group.id">
            <div
              class="group-list"
              :class="{ open: isGroupOpen === idx }"
              @click="setGroupOpen(idx)"
            >
              <span><i class="fa fa-caret-right"></i> {{ group.name }}</span>
              <div
                class="group-list-wrapper"
                v-if="
                  groupFlowsList(group.tags) &&
                  groupFlowsList(group.tags).length
                "
              >
                <div
                  class="item-wrapper"
                  v-for="flow in groupFlowsList(group.tags)"
                  :key="flow.id"
                  :style="{ zoom: getZoom }"
                  :class="{ checked: isFlowCardSelected(flow) }"
                >
                  <div
                    class="data-dz-thumbnail-bg-overlay loading custom-loader"
                    v-if="showLoadingOverlay.includes(flow.id)"
                  >
                    <div class="progress-status"></div>
                    <div class="progress-icon"></div>
                  </div>
                  <div class="header">
                    <ul class="tools">
                      <li
                        data-dz-delete
                        v-if="flow.access_level != 'owner'"
                        class="leave"
                        title="Verlassen"
                        v-on:click="requestLeaveConfirmation(flow)"
                      >
                        <img src="../assets/img/quit.svg" alt="quit" />
                        <a>leave</a>
                      </li>
                      <li
                        class="download"
                        title="Download"
                        v-on:click="downloadFlowAsJson(flow.id)"
                        v-if="flow.access_level != 'execute'"
                      >
                        <img src="../assets/img/download.svg" alt="download" />
                        <a>Download </a>
                      </li>
                      <li
                        data-dz-delete
                        v-if="flow.access_level != 'execute'"
                        title="Duplizieren"
                        class="duplicate"
                        v-on:click="duplicateElement(flow)"
                      >
                        <img
                          src="../assets/img/duplicate.svg"
                          alt="duplicate"
                        />
                        <a>duplicate</a>
                      </li>
                      <li
                        data-dz-delete
                        v-if="flow.access_level != 'execute'"
                        title="Löschen"
                        class="delete"
                        v-on:click="requestRemoveConfirmation(flow)"
                      >
                        <img src="../assets/img/delete-icon.svg" alt="delete" />
                        <a>delete</a>
                      </li>
                      <li
                        class="share"
                        title="Teilen"
                        v-if="flow.access_level != 'execute'"
                        v-on:click="showShareFlow(flow)"
                      >
                        <img src="../assets/img/user.svg" alt="share" />
                        <a>share</a>
                      </li>
                    </ul>
                  </div>
                  <div class="content">
                    <h1
                      class="flow-title"
                      type="text"
                      @focus="isSortActive = false"
                      @change="updateFlow(flow.id, flow.name)"
                    >
                      {{ flow.name }}
                    </h1>
                  </div>
                  <div class="footer">
                    <router-link
                      v-if="flow.access_level != 'execute'"
                      class="btn"
                      :to="{
                        path: '/',
                        query: {
                          section: 'process-designer',
                          process: flow.id,
                        },
                      }"
                      >Bearbeiten</router-link
                    >
                    <router-link
                      v-show="flow.type != 'action'"
                      :to="{
                        name: 'process-runner',
                        params: {
                          id: flow.id,
                        },
                      }"
                      class="btn run-process"
                      :class="{ big: flow.access_level == 'execute' }"
                    >
                      Starten
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="white-space"></div>
          </div>
        </div>
        <div v-else>No Groups Found!!</div>
      </div>
      <CopyEmbedModal
        v-if="copyEmbedModal.visible"
        :copyEmbedModal="copyEmbedModal"
        @closeModal="closeCopyEmbedModal"
      />

      <div
        class="process-list-wrapper"
        v-show="!isLoading && !isGroupFlowListOpen"
      >
        <div
          class="item-wrapper"
          v-for="p in sortedProcessList"
          :key="p.id"
          :style="{ zoom: getZoom }"
          :class="{ checked: isFlowCardSelected(p) }"
        >
          <div
            class="data-dz-thumbnail-bg-overlay loading custom-loader"
            v-if="showLoadingOverlay.includes(p.id)"
          >
            <div class="progress-status"></div>
            <div class="progress-icon"></div>
          </div>
          <div class="header">
            <ul class="tools">
              <li
                v-if="
                  p.type != 'action' &&
                  p.access_level != workFlowAccessLevel.EDIT_CONTENT
                "
                class="embed"
                title="Einbetten"
                @click="getWorkFlowData(p)"
              >
                <img
                  src="../assets/img/code-tag.svg"
                  alt="code"
                  class="code-tag-icon"
                />
                <p v-show="embedCodeCopied === p.id" class="message">
                  Kopiert!
                </p>
                <a class="link">Einbetten</a>
              </li>
              <li
                data-dz-delete
                v-if="p.access_level != 'owner'"
                class="leave"
                title="Verlassen"
                v-on:click="requestLeaveConfirmation(p)"
              >
                <img src="../assets/img/quit.svg" alt="quit" />
                <a>leave</a>
              </li>
              <li
                class="download"
                title="Download"
                v-on:click="downloadFlowAsJson(p.id)"
                v-if="
                  p.access_level != workFlowAccessLevel.EXECUTE &&
                  p.access_level != workFlowAccessLevel.EDIT_CONTENT
                "
              >
                <img src="../assets/img/download.svg" alt="download" />
                <a>Download </a>
              </li>
              <li
                data-dz-delete
                v-if="
                  p.access_level != workFlowAccessLevel.EXECUTE &&
                  p.access_level != workFlowAccessLevel.EDIT_CONTENT
                "
                title="Duplizieren"
                class="duplicate"
                v-on:click="duplicateElement(p)"
              >
                <img src="../assets/img/duplicate.svg" alt="duplicate" />
                <a>duplicate</a>
              </li>
              <li
                data-dz-delete
                v-if="
                  p.access_level != 'execute' &&
                  p.access_level != workFlowAccessLevel.EDIT_CONTENT
                "
                title="Löschen"
                class="delete"
                v-on:click="requestRemoveConfirmation(p)"
              >
                <img src="../assets/img/delete-icon.svg" alt="delete" />
                <a>delete</a>
              </li>
              <li
                class="share"
                title="Teilen"
                v-if="!['execute', 'edit-content'].includes(p.access_level)"
                v-on:click="showShareFlow(p)"
              >
                <img src="../assets/img/user.svg" alt="share" />
                <a>share</a>
              </li>
            </ul>
          </div>
          <div class="content">
            <h1
              class="flow-title"
              type="text"
              @focus="isSortActive = false"
              @change="updateFlow(p.id, p.name)"
            >
              {{ p.name }}
            </h1>
          </div>
          <div class="footer">
            <router-link
              v-if="p.access_level != 'execute'"
              class="btn"
              :to="{
                path: '/',
                query: {
                  section: 'process-designer',
                  process: p.id,
                },
              }"
              >Bearbeiten</router-link
            >
            <router-link
              v-show="p.type != 'action'"
              :to="{
                name: 'process-runner',
                params: {
                  id: p.id,
                },
              }"
              class="btn run-process"
              :class="{ big: p.access_level == 'execute' }"
            >
              Starten
            </router-link>
            <!-- <a  class="btn" @click="openModal(p, idx)"> add tag </a> -->
          </div>
        </div>
        <div class="white-space"></div>
      </div>
    </div>
    <div class="loading" v-show="isLoading">
      <div class="progress-icon dark-color"></div>
    </div>
    <htmlViewer
      v-if="htmlViewerModal.isHtmlViewerVisible"
      @close="closeHtmlViewer"
      :myHtml="htmlViewerModal.myHtml"
    ></htmlViewer>
    <flow-modal
      v-if="flowModalSettings.isFlowModalVisible"
      @close="closeFlowModal"
      :flowId="selectedFlow"
    ></flow-modal>
    <removeConfirmationModal
      v-if="
        confirmationModal.isRemoveConfirmationVisible && !selectedFlows.length
      "
      @close="closeRemoveConfirmationModal"
      :id="selectedFlow.id"
      :name="selectedFlow.name"
      :actionType="confirmationModal.actionType"
      :resourceType="resourceType"
      @confirmRemove="removeFlow"
      @confirmLeave="leaveFlow"
    ></removeConfirmationModal>
    <removeConfirmationModal
      v-if="
        confirmationModal.isRemoveConfirmationVisible && selectedFlows.length
      "
      @close="closeRemoveConfirmationModal"
      :flows="selectedFlows"
      :actionType="confirmationModal.actionType"
      :resourceType="resourceType"
      @confirmRemove="removeFlow"
      @confirmLeave="leaveFlow"
    ></removeConfirmationModal>
    <modal-box
      class="modal-window"
      v-bind:title="modalBox.title"
      v-bind:message="modalBox.msg"
      v-bind:buttonCaption="modalBox.btnCaption"
      v-if="isModalBoxVisible"
      @close="hideModalBox"
    />
    <AddGroupModal
      :tagList="getFlowTagList"
      v-if="isAddGroupModalIsOpen"
      :groups="groups"
      @addGroup="addGroup"
      @closeModal="isAddGroupModalIsOpen = !isAddGroupModalIsOpen"
    ></AddGroupModal>
    <AddTagModal
      :processList="ProcessList"
      :tagList="getFlowTagList"
      :flowId="isTagModalOpen"
      :idx="processIdx"
      v-if="isTagModalOpen"
      @closeModal="isTagModalOpen = ''"
    ></AddTagModal>
  </div>
</template>

<script>
//import ProcessFiles from '../assets/files/process/*.json'
import htmlViewer from './modals/htmlViewer.vue';
import flowModal from './modals/flowShareModal.vue';
import removeConfirmationModal from './modals/removeConfirmModal.vue';
import { schema } from '../models/VueModels';
import ModalBox from './modals/ModalBox.vue';
import NoFlows from './NoFlows.vue';
import workFlowDataSchema from '../assets/data-schemas/workFlowDataSchema.json';
import AddGroupModal from './modals/AddGroupModal.vue';
import AddTagModal from './modals/addTagModal.vue';
import { workFlowAccessLevel } from '../enum/auth.enum';
import { mapActions } from 'vuex';
import GeneralDropdown from './core/general-dropdown.vue';
import {
  getWorkFlowById,
  deleteWorkflowById,
} from '../services/workflow.service';
import { getFlowLastId } from '../utils/helpers';
import CopyEmbedModal from './modals/CopyEmbedModal.vue';

export default {
  name: 'processList',
  data() {
    return {
      workFlowAccessLevel: workFlowAccessLevel,
      embedCodeCopied: '',
      lastID: null,
      showLoadingOverlay: [],
      isSortActive: true,
      flowModalSettings: {
        isFlowModalVisible: false,
      },
      modalBox: {
        showAfterQueueIsDone: false,
        title: '',
        msg: [],
        btnCaption: 'Schliessen',
      },
      isModalBoxVisible: false,
      zoom: 70,
      htmlViewerModal: {
        isHtmlViewerVisible: false,
        myHtml: null,
      },
      confirmationModal: {
        actionType: null,
        isRemoveConfirmationVisible: false,
      },
      isCreateFlowOptionsVisible: false,
      requestError: null,
      isRefreshing: false,
      showMore: false,
      showActionsDropdown: false,
      searchActive: false,
      search: '',
      isUploadFileVisible: false,
      isAddFilterVisible: false,
      filters: [],
      activeFilter: null,
      isClickOutsideDelayed: true,
      isEditFilterVisible: false,
      operatorOption: [
        {
          label: 'beinhaltet',
          opperand: '.includes(',
          visibility: 'all',
        },
        {
          label: 'beinhaltet nicht',
          opperand: '!.includes(',
          visibility: 'all',
        },
        {
          label: 'ist genau',
          opperand: '==',
          visibility: 'all',
        },
        {
          label: 'ist nicht',
          opperand: '!=',
          visibility: 'all',
        },
        {
          label: 'ist grösser',
          opperand: '>',
          visibility: 'number',
        },
        {
          label: 'ist grösser oder gleich',
          opperand: '>=',
          visibility: 'number',
        },
        {
          label: 'ist kleiner',
          opperand: '<',
          visibility: 'number',
        },
        {
          label: 'ist kleiner oder gleich',
          opperand: '<=',
          visibility: 'number',
        },
      ],
      selectedFlows: [],
      resourceType: null,
      isGroupFlowListOpen: false,
      groups: [],
      isLoading: true,
      isGroupOpen: '',
      isAddGroupModalIsOpen: false,
      isTagModalOpen: '',
      copyEmbedModal: {
        visible: false,
        loading: false,
        selectedFlow: {},
        elements: [],
      },
    };
  },
  methods: {
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    async getWorkFlowData(workflow) {
      this.copyEmbedModal.selectedFlow = workflow;
      this.copyEmbedModal.visible = true;
      this.copyEmbedModal.loading = true;

      try {
        const response = await this.getFlow(workflow.id);
        if (response.tasks.length > 0) {
          const flowOutput = response.tasks[0].props.formTrigger.elements;
          this.copyEmbedModal.elements = flowOutput;
          this.copyEmbedModal.loading = false;
        } else {
          this.showToaster('Kein Schema gefunden', 'Fehler', 'danger');
          throw new Error('no schema provided');
        }
      } catch (error) {
        console.log(error);
        this.closeCopyEmbedModal();
      }
    },
    closeCopyEmbedModal() {
      this.copyEmbedModal.visible = false;
      this.copyEmbedModal.selectedFlow = {};
      this.copyEmbedModal.elements = [];
      this.copyEmbedModal.loading = false;
    },
    ...mapActions({
      removeSingleFlowById: 'removeSingleFlowByIdAction',
    }),
    addGroup(data) {
      this.groups.push(data);
    },
    openModal(p, idx) {
      this.isTagModalOpen = p.id;
      this.processIdx = idx;
    },
    newID() {
      return getFlowLastId(this);
    },
    checkFlowMatchesModel(flowModel, importedFlow) {
      const validKeys = Object.keys(flowModel);
      const receivedKeys = Object.keys(importedFlow);
      return (
        validKeys.length === receivedKeys.length &&
        validKeys.every((value) => ~receivedKeys.indexOf(value))
      );
    },

    getImgUrl(img) {
      var images = require.context('../assets/img/', false, /\.png$/);
      return images(img);
    },

    async createNewFlow() {
      let rslt = await this.$store.dispatch('createNewFlow', {
        id: this.newID(),
        type: 'app',
      });

      if (rslt == 'Access Token has expired') {
        localStorage.clear(),
          this.$router.push({
            name: 'auth',
            params: { message: 'Sitzung abgelaufen' },
          });
      } else this.goToProcess(rslt);
    },

    async downloadFlowAsJson(id) {
      let process = await this.getFlow(id);

      // Copy and reset owner & tableID
      var deepCopy = Object.assign({}, JSON.parse(JSON.stringify(process)));
      deepCopy.id = this.newID();
      deepCopy.owner = '';

      // TODO: Delete if there are no more old flows
      if (deepCopy.hasOwnProperty('tableID')) deepCopy.tableID = '';
      else deepCopy['tableID'] = '';

      // Remove input & output
      deepCopy.tasks.forEach((part, index, arr) => {
        arr[index].output = [];
        arr[index].input = [];
      });

      // Create data string & export
      let dataStr =
        'data:text/json;charset=utf-8,' +
        encodeURIComponent(JSON.stringify(deepCopy));
      let link = document.createElement('a');
      link.setAttribute('href', dataStr);
      link.setAttribute('download', deepCopy.name + '.json');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    async getFlow(id) {
      const response = await getWorkFlowById(id);
      if (response && response.status === 200) {
        return response.data;
      }
    },

    async goToProcess(id) {
      this.$router.push({
        path: '/',
        query: {
          section: 'process-designer',
          process: id,
        },
      });
    },

    toggleFileUploader() {
      this.$refs.uploadBtn.click();
    },

    toggleCreateFlowOptions() {
      this.isCreateFlowOptionsVisible = !this.isCreateFlowOptionsVisible;
    },

    toggleUploadFile() {
      this.isUploadFileVisible = !this.isUploadFileVisible;
    },

    hideModalBox() {
      this.isModalBoxVisible = false;
    },

    hideFileUploader() {
      this.isUploadFileVisible = false;
    },
    importFlow() {
      this.toggleCreateFlowOptions();
      this.toggleUploadFile();
      this.isLoading = true;

      // Get file from input
      let file = this.$refs.uploadBtn.files[0];

      var reader = new FileReader();
      // Function to read file values
      var self = this;
      reader.onload = function () {
        var importedProcess = JSON.parse(reader.result);

        // Assign current ID to import
        importedProcess.id = self.newID();
        importedProcess.owner = self.user.username;

        // Check if import matches flow-model
        let flowModels = [
          schema.models.FlowV1,
          schema.models.FlowV2,
          schema.models.FlowV3,
          schema.models.FlowV4,
        ];

        var flowMatchesModel = false;

        for (let f of flowModels) {
          let match = self.checkFlowMatchesModel(f, importedProcess);
          if (match == true) {
            flowMatchesModel = true;
            break;
          }
        }
        if (flowMatchesModel) self.saveProcess(importedProcess, true);
        else {
          // Display error modal
          self.$set(self.modalBox, 'showAfterQueueIsDone', false);
          self.$set(
            self.modalBox.msg,
            self.modalBox.msg.length,
            'Der importierte Flow entspricht nicht dem Schema.'
          );
          self.isLoading = false;
          self.isModalBoxVisible = true;
        }
      };
      this.isUploadFileVisible = false;
      reader.readAsText(file);
    },
    saveProcess(flow, redirect) {
      this.$store
        .dispatch('saveFlow', {
          flow: flow,
        })
        .then((message) => {
          // Success always returns the ID as number
          if (typeof message == 'number') return message;
          else throw new Error(message);
        })
        .then((id) => {
          if (redirect) {
            this.isLoading = false;
            this.goToProcess(id);
          }
        })
        .catch((e) => {
          this.requestError = e;
        });
    },
    async removeFlow(id) {
      try {
        this.showLoadingOverlay.push(id);

        const filteredFlowsList = this.ProcessList.filter(
          (flow) => flow.id != id
        );
        const deleteWorkflowResponse = await deleteWorkflowById(id);

        if (deleteWorkflowResponse.status == 200) {
          await this.$store.commit('addFlow', filteredFlowsList);
        }
        this.showLoadingOverlay.splice(this.showLoadingOverlay.indexOf(id), 1);
      } catch (error) {
        this.showLoadingOverlay.splice(this.showLoadingOverlay.indexOf(id), 1);
        this.showToaster('etwas ist schief gelaufen', 'Fehler', 'danger');
      }
    },
    requestRemoveConfirmation(p) {
      this.selectedFlow = p;
      this.resourceType = 'flow';
      this.$set(this.confirmationModal, 'actionType', 'remove');
      this.$set(this.confirmationModal, 'isRemoveConfirmationVisible', true);
    },
    requestLeaveConfirmation(p) {
      this.selectedFlow = p;
      this.resourceType = 'flow';
      this.$set(this.confirmationModal, 'actionType', 'leave');
      this.$set(this.confirmationModal, 'isRemoveConfirmationVisible', true);
    },
    duplicateElement(flow) {
      this.isLoading = true;
      var url = process.env.VUE_APP_DATA_API;
      url += '/duplicate-flow/' + flow.id;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      fetch(url, {
        headers: myHeaders,
        method: 'PUT',
      })
        .then((response) => response.json())
        .then(() => {
          // Get all flows
          setTimeout(() => {
            this.$store.dispatch('getFlows');
            this.isLoading = false;
          }, 1000);
        })
        .catch((e) => {
          this.isLoading = false;
          this.requestError = e;
        });
    },
    async leaveFlow(id) {
      const url = `${process.env.VUE_APP_DATA_API}/flow/iam/${id}`;

      let myHeaders = new Headers();
      myHeaders.append(
        'Authorization',
        'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
      );

      const response = await fetch(url, {
        headers: myHeaders,
        method: 'DELETE',
      });
      const responseJson = await response.json();
      if (responseJson.ResponseMetadata.HTTPStatusCode == 200) {
        this.removeSingleFlowById(id);
        this.showLoadingOverlay.splice(this.showLoadingOverlay.indexOf(id), 1);
      }
    },
    async updateFlow(id, name) {
      let flow = await this.getFlow(id);
      flow.name = name;
      this.saveProcess(flow, false);
    },
    closeHtmlViewer() {
      this.$set(this.htmlViewerModal, 'isHtmlViewerVisible', false);
    },
    showShareFlow(p) {
      this.selectedFlow = p.id;
      this.$set(this.flowModalSettings, 'isFlowModalVisible', true);
    },
    closeFlowModal() {
      this.$set(this.flowModalSettings, 'isFlowModalVisible', false);
    },
    closeRemoveConfirmationModal() {
      this.confirmationModal.isRemoveConfirmationVisible = false;
    },
    // set focus on input (search)
    toggleSearch() {
      this.searchActive = !this.searchActive;
      if (this.searchActive) {
        this.$refs.search.focus();
      } else {
        this.search = '';
      }
    },
    hideAddFilter() {
      if (this.isAddFilterVisible) {
        this.removeEmptyFilter();
        this.isAddFilterVisible = false;
        this.activeFilter = null;
      }
    },
    showAddFilter() {
      if (this.isAddFilterVisible) {
        this.removeEmptyFilter();
        this.isAddFilterVisible = false;
        this.activeFilter = null;
        return null;
      }
      const activeFilterData = {
        id: this.newID(),
        caption: null,
        property: null,
        opperand: null,
        value: null,
      };
      this.activeFilter = activeFilterData;
      this.isAddFilterVisible = true;
      this.$set(this.filters, this.filters.length, activeFilterData);
    },
    addFilterCaption(propertyName) {
      this.activeFilter.property = propertyName;
      workFlowDataSchema.forEach((data) => {
        if (data.name == propertyName) {
          this.activeFilter.caption = data.label;
          this.activeFilter.type = data.type;
          this.activeFilter.options = data.options;
          this.activeFilter.value = '';
        }
      });
      this.$forceUpdate();
    },
    showEditFilter(filter) {
      this.activeFilter = filter;
      this.isClickOutsideDelayed = true;
      this.isEditFilterVisible = true;
      setTimeout(() => (this.isClickOutsideDelayed = false), 300);
    },
    hideEditFilter() {
      if (this.isEditFilterVisible && !this.isClickOutsideDelayed) {
        this.isEditFilterVisible = false;
        this.activeFilter = null;
      }
    },
    removeFilter(id) {
      this.filters = this.filters.filter((filter) => filter.id != id);
    },
    removeEmptyFilter() {
      this.filters = this.filters.filter((filter) => filter.property != null);
    },
    formatLabel(l) {
      if (l.length > 25) return l.slice(0, 25) + '...';
      else return l;
    },
    async refreshTable() {
      this.isRefreshing = true;
      await this.$store.dispatch('getFlows');
      this.isRefreshing = false;
    },
    onCardCheck(flow) {
      if (this.selectedFlows.includes(flow.id) && this.selectedFlows.length) {
        this.selectedFlows.splice(
          this.selectedFlows.indexOf((e) => e.id === flow.id),
          1
        );
      } else {
        this.selectedFlows.push(flow);
      }
    },
    isFlowCardSelected(flow) {
      return this.selectedFlows.includes(flow.id);
    },
    toggleMore() {
      this.showMore = !this.showMore;
    },
    toggleActionsDropdown() {
      this.showActionsDropdown = !this.showActionsDropdown;
    },
    groupFlowsList(tag) {
      if (tag) {
        return this.sortedProcessList.filter((e) => {
          return e.tags.some((el) => tag.includes(el));
        });
      }
    },
    setGroupOpen(id) {
      if (this.isGroupOpen === '') {
        this.isGroupOpen = id;
      } else {
        if (this.isGroupOpen === id) {
          this.isGroupOpen = '';
        } else {
          this.isGroupOpen = id;
        }
      }
    },
    addFilterOpperand(opperand, label) {
      this.activeFilter.opperand = opperand;
      this.activeFilter.opperandLabel = label;
      this.$forceUpdate();
    },
    addFilterValue(val, name) {
      this.activeFilter.value = val;
      this.activeFilter.valueName = name;
    },
    showFilterOperator(operator) {
      return (
        operator.visibility === 'all' ||
        (operator.visibility === 'number' &&
          this.activeFilter.type === 'number')
      );
    },
  },
  created() {
    // Delay to prevent "no item screen" before rendering item
    setTimeout(() => {
      this.isLoading = false;
    }, 4000);
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    hasAddNewFlowPermission() {
      return this.$store.state.addNewFlowPermission;
    },
    noData() {
      return this.ProcessList.length < 1;
    },
    dataSchema() {
      return workFlowDataSchema;
    },
    isZoomVisible() {
      return !this.noData && !this.isLoading;
    },
    getZoom() {
      return this.zoom / 100;
    },
    ProcessList() {
      return this.$store.state.flows;
    },
    customFilteredProcessList() {
      const filterItems = this.ProcessList;
      if (this.filters.length <= 0) return filterItems;
      else {
        // Get only filters that can be interpreted
        let readyFilters = [];
        for (let filter of this.filters) {
          if (filter.property && filter.value && filter.opperand) {
            readyFilters.push(filter);
          }
        }
        if (readyFilters.length > 0) {
          let filterString = '';
          for (let f of readyFilters) {
            // Simple type filter
            if (f.opperand == '==' || f.opperand == '!=') {
              filterString +=
                'String(e.' +
                f.property +
                ').toLowerCase()' +
                f.opperand +
                ' "' +
                f.value +
                '".toLowerCase()' +
                ' && ';
              // filter vor Numbers
            } else if (
              f.opperand == '<' ||
              f.opperand == '<=' ||
              f.opperand == '>' ||
              f.opperand == '>='
            ) {
              filterString +=
                'e.' +
                f.property +
                ' ' +
                f.opperand +
                ' "' +
                f.value +
                '"' +
                ' && ';
            } else if (f.opperand == '!.includes(') {
              filterString +=
                '!String(e.' +
                f.property +
                ').toLowerCase()' +
                ".includes('" +
                f.value +
                "'.toLowerCase())" +
                ' &&';
            } else {
              // Filter for includes
              filterString +=
                'String(e.' +
                f.property +
                ').toLowerCase()' +
                f.opperand +
                '"' +
                f.value +
                '".toLowerCase())' +
                ' &&';
            }
          }
          filterString = filterString.slice(0, filterString.length - 3);

          // eslint-disable-next-line no-unused-vars
          return filterItems.filter((e) => eval(filterString));
        } else return filterItems;
      }
    },
    sortedProcessList() {
      if (this.search !== '') {
        return this.customFilteredProcessList.filter(
          (i) =>
            i.hasOwnProperty('name') &&
            i.name.toLowerCase().includes(this.search.toLowerCase())
        );
      } else if (this.isSortActive) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return this.customFilteredProcessList.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      } else {
        return this.customFilteredProcessList;
      }
    },
    showGroupAction() {
      return this.selectedFlows.length;
    },
    getFlowTagList() {
      const eachFlowTags = this.ProcessList.map(
        (process) => process.tags
      ).flatMap((num) => num);
      const finalTagList = eachFlowTags.filter(
        (tag, index) => eachFlowTags.indexOf(tag) === index
      );
      return finalTagList;
    },
    getActiveFilterOption() {
      if (this.activeFilter.caption) {
        return this.activeFilter.options;
      }
      return [];
    },
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.eventSetDrag = function () {
          el.setAttribute('data-dragging', 'yes');
        };
        el.eventClearDrag = function () {
          el.removeAttribute('data-dragging');
        };
        el.eventOnClick = function (event) {
          const dragging = el.getAttribute('data-dragging');
          // Check that the click was outside the el and its children, and wasn't a drag
          if (!(el == event.target || el.contains(event.target)) && !dragging) {
            // call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener('touchstart', el.eventClearDrag);
        document.addEventListener('touchmove', el.eventSetDrag);
        document.addEventListener('click', el.eventOnClick);
        document.addEventListener('touchend', el.eventOnClick);
      },
      unbind(el) {
        document.removeEventListener('touchstart', el.eventClearDrag);
        document.removeEventListener('touchmove', el.eventSetDrag);
        document.removeEventListener('click', el.eventOnClick);
        document.removeEventListener('touchend', el.eventOnClick);
        el.removeAttribute('data-dragging');
      },
    },
  },
  components: {
    htmlViewer,
    flowModal,
    removeConfirmationModal,
    ModalBox,
    NoFlows,
    AddGroupModal,
    AddTagModal,
    GeneralDropdown,
    CopyEmbedModal,
  },
};
</script>

<style scoped>
.wrapper {
  height: 100%;
}

.process-list {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: scroll;
  width: 100%;
  height: calc(78vh - 140px);
  scrollbar-width: thin;
}
.process-list.full-height {
  height: calc(94vh - 155px);
}
.item-wrapper:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgb(0 0 0 / 70%);
  opacity: 0;
  visibility: hidden;
  border-radius: 0 0 12px 12px;
  transition: all 300ms ease-in-out;
}

.show-overlay:before {
  opacity: 1;
  visibility: visible;
}

.item-wrapper {
  width: 466px;
  background: #fff;
  margin: 0 40px 40px 0;
  -webkit-box-shadow: 0 1px 2px rgb(43 59 93 / 29%);
  box-shadow: 0 1px 2px rgb(43 59 93 / 29%);
  cursor: pointer;
  border-radius: 12px;
  transition: box-shadow 0.2s ease, transform 0.2s ease,
    -webkit-box-shadow 0.2s ease, -webkit-transform 0.2s ease;
  text-align: left;
  zoom: 0.7;
  padding: 25px;
  position: relative;
}

.item-wrapper:hover {
  box-shadow: 0px 12px 24px 0px rgb(0 0 0 / 20%);
  transform: translate3d(0, -4px, 0);
}

.item-wrapper .flow-title {
  color: #424956;
  font-size: 30px;
  font-weight: 300;
  text-align: left;
  width: 100%;
  line-height: 45px;
  margin: 0;
  word-break: break-word;
}

.process-list-wrapper {
  display: flex;
  margin-top: 45px;
  flex-wrap: wrap;
}

.img-wrapper {
  width: 100%;
  height: 172px;
}

.logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

p {
  margin: 0 30px;
}

.round-button-wrapper {
  width: 200px;
  display: block;
  margin-left: 85%;
  position: absolute;
  height: 60px;
  z-index: 6;
}

.round-button {
  cursor: pointer;
  display: block;
  color: white;
  border-radius: 50%;
  background-color: rgb(255, 51, 102);
  height: 60px;
  text-align: center;
  width: 60px;
  line-height: 59px;
  font-size: 30px;
  font-weight: 100;
  box-shadow: 0.5px 0.87px 5px 0 rgba(0, 0, 0, 0.28);
  position: absolute;
  top: -33px;
}

.round-button img {
  width: 30px;
}

.round-button-wrapper.clicked .round-button {
  transform: rotate(45deg);
}

.round-button:hover {
  transform: scale(1.1) rotate(0);
}

.round-button-wrapper.clicked .round-button:hover {
  transform: scale(1.1) rotate(45deg);
}

.plus-btn-options {
  -webkit-box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  background-color: #ffff;
  bottom: unset;
  margin-top: 50px;
  margin-bottom: unset;
  margin-right: 32px;
  margin-left: -331px;
}

.plus-btn-options.no-shadow {
  -webkit-box-shadow: none;
  box-shadow: none;
  background-color: transparent;
  margin-left: 0;
  margin-top: 30px;
}

.plus-btn-options .option {
  text-align: center;
  display: inline-block;
  padding: 47px 15px 45px;
  border-right: solid 1px #dbdee5;
  cursor: pointer;
  width: 165px;
}

.plus-btn-options .option h2 {
  font: 600 15px/22px brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  color: #434c5e;
  text-transform: uppercase;
  margin-top: 14px;
  margin-bottom: 0px;
}

.plus-btn-options .icon {
  font-size: 65px;
}

.data-dz-thumbnail-bg-overlay:hover {
  opacity: 1;
}

.data-dz-thumbnail-bg-overlay {
  z-index: 5;
  top: 0;
  overflow: hidden;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  left: 0;
  height: 172px;
  width: 100%;
  position: absolute;
  top: 0;
  opacity: 0;
  background-color: rgba(25, 29, 38, 0.85);
  -webkit-transition: opacity 450ms ease-in-out;
  -o-transition: opacity 450ms ease-in-out;
  transition: opacity 450ms ease-in-out;
}

a.btn {
  font-family: brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  letter-spacing: 1px;
  line-height: 44px;
  transition: all 0.2s ease-in-out;
  z-index: 2;
  text-decoration: none;
  left: 0;
  right: 0;
  position: unset !important;
  top: 65px;
  width: fit-content;
  height: 47px;
  color: black;
  border: 1px solid #bdbfc5;
  border-radius: 5px;
  margin: 0;
  text-transform: none;
  font-size: 21px;
  font-weight: 300;
  padding: 0 18px 0px;
  display: inline-block;
  margin-right: 5px;
}

a.btn.edit-process {
  top: 70px;
}

a.btn:hover {
  background-color: rgb(39 39 42 / 5%);
}

.tools li.delete a {
  background-position: -129px -759px;
}

/* 
.tools li.duplicate a {
  background-image: url("../assets/img/codelos-icons.svg");
  background-size: 32px 20px;
  background-position: -18px -3px; 
}
*/
.tools li.leave a {
  background-image: url('../assets/img/codelos-icons.svg');
  background-size: 32px 20px;
  background-position: -1px -3px;
}

.tools li img {
  transition: opacity 0.2s ease-in-out;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
  padding: 6px;
  border-radius: 5px;
  width: 36px;
}

.tools li i {
  color: #505050;
  font-size: 20px;
  font-weight: 600;
  top: 2.4px;
  position: relative;
  padding: 6px;
}

.tools li img:hover,
.tools li i:hover {
  background-color: rgb(39 39 42 / 5%);
}

.tools {
  position: unset;
  right: 17px;
  top: 7px;
  z-index: 2;
  border: 0px solid transparent;
  transition: visibility 0s ease 450ms, box-shadow 0.2s ease,
    -webkit-box-shadow 0.2s ease;
  margin-top: 0;
  width: fit-content;
  height: 29px;
  margin-bottom: 0;
  float: right;
}

.tools li {
  float: left;
  list-style: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

.tools a {
  text-indent: -9999px;
}

.tools li > a {
  zoom: 1.2;
  opacity: 0.7;
  background-image: unset;
  background-size: unset;
  background-position: unset;
  width: 14px;
  height: 13px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  transition: opacity 0.2s ease-in-out;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
}

.tools li > a:hover {
  opacity: 1;
}

.tools li.share a {
  background-position: -868px -268px;
}

.tools li.download a {
  background-position: -868px -646px;
}

.tools li.iam i {
  color: rgb(194, 194, 194);
  font-size: 15px;
}

.tools li.delete a {
  background-position: -129px -759px;
}

.progress-icon {
  display: block;
  position: relative;
  left: auto;
  top: 108px;
  width: 70px;
  height: 70px;
}

.progress-icon {
  left: 152px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon 1.2s linear infinite;
}

.progress-icon.dark-color:after {
  border-color: #1f2532 transparent #1f2532 transparent;
  width: 100px;
  height: 100px;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* .loading .progress-icon {
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  bottom: unset;
} */

.zoom {
  width: 170px;
  position: relative;
  margin: unset;
  padding: unset;
  top: unset;
  bottom: unset;
  margin-top: 60px;
  margin-left: 73%;
}

.slider {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  height: 2px;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #404755;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #404755;
  cursor: pointer;
}

.toolbar .share .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: 0 -759px;
}

.option.round {
  border-radius: 50%;
  display: block;
  border: none;
  width: 60px;
  height: 60px;
  padding: 0;
  font-size: 18px;
  line-height: 60px;
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  background: #ffff;
  margin-top: 14px;
  color: #1f2532;
}

:v-deep .tooltip {
  top: 0;
  left: -500px;
  right: 600px;
  bottom: 0;
}

.content {
  margin: 0px 30px;
  -webkit-box-flex: 1;
  flex: 1;
  padding-top: 55px;
  padding-bottom: 55px;
  min-height: 264px;
}

.scrollable {
  min-height: 100%;
}

.header {
  width: 100%;
  height: 35px;
}

.footer {
  height: 52px;
}

.white-space {
  width: 100%;
  height: 0px;
  display: grid;
}
/* .custom-loader.show {
  opacity: 1 !important;
} */
.custom-loader {
  height: 100%;
  z-index: 1;
  opacity: 1 !important;
}
.data-dz-thumbnail-bg-overlay.custom-loader:hover {
  opacity: 0;
}

.custom-loader .progress-icon {
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
  height: auto;
}
.custom-loader + .header {
  position: relative;
  z-index: 2;
}

.process-list-topbar {
  display: flex;
  /* padding-right: 30px; */
  -webkit-box-pack: end;
  justify-content: flex-end;
}

.menu3-bar .list-item {
  padding-left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
}

.menu3-bar .list-item > li {
  text-align: -webkit-match-parent;
  margin: 0 26px 0 0;
  vertical-align: top;
  display: inline-block;
  cursor: pointer;
}

.menu3-bar .list-item > li.item-mode-toggle {
  margin-top: 40px;
  font-size: 23px;
  color: #646f81;
}
.menu3-bar .list-item > li.add-folder {
  margin-top: 41px;
  font-size: 21px;
  color: #646f81;
}
.settings-button-wrapper {
  position: relative;
  display: block;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
}

.settings-button-wrapper img {
  width: 20px;
}

.settings-button-wrapper > div {
  padding: 0.375rem 0.75rem;
  box-sizing: border-box;
  cursor: pointer;
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-359deg);
  }
}
.refresh.rotation img {
  animation: rotation 1.5s infinite linear;
}

.refresh {
  padding-top: 7px;
}

.checker span {
  background-image: url(../assets/img/project-sprite.png);
  background-size: 882px 840px;
  background-position: -710px -316px;
  height: 31px;
  width: 30px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  text-align: center;
}

.checker span.checked {
  background-position: -398px -283px;
  position: relative;
  top: 8px;
}

.checker {
  display: inline-block;
}
.checked.item-wrapper {
  box-shadow: 0 0 0 2px #1fc281;
}

/*bottom bar*/
.group-actions .inner {
  width: 100%;
  text-align: left;
  display: block;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  line-height: 22px;
  position: relative;
  top: 30%;
}

.group-actions .toolbar {
  margin: 3px 0 0 -179px;
  position: absolute;
  left: 50%;
  padding: 0;
}

.group-actions .toolbar .share .link {
  background-image: url(http://localhost:8080/img/project-sprite.1c2e7465.png);
  background-position: 0 -759px;
}

.group-actions .toolbar .link {
  cursor: pointer;
  top: 50%;
  display: block;
  text-indent: -9999px;
  opacity: 0.9;
  background-size: 882px 840px;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  display: block;
  overflow: hidden;
}

.group-actions .toolbar li {
  float: left;
  margin: 0 15px;
  list-style: none;
  padding: 0;
  text-align: -webkit-match-parent;
}

.select-all-wrapper {
  float: right;
  margin-right: 100px;
  margin-top: 0;
  top: 30%;
  position: relative;
}

.btn-select-all {
  background-color: white;
  border-style: none;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  font-size: 16px;
  margin-left: 12.5px;
}

.group-actions .toolbar li.download .link {
  background-position: -800px 0;
  width: 18px;
  height: 18px;
}

.group-actions .toolbar .dropdown .link {
  background-position: -463px -759px;
  width: 18px;
  height: 4px;
  top: 8px;
}

.toolbar .more .toggle-list-wrapper.toggle-up {
  margin-top: -100%;
  padding: 20px 0px 20px 0px;
  min-width: 195px;
  left: 0;
  top: 0;
}

.toggle-list-wrapper {
  background-color: #ffff;
  position: relative;
  left: -53px;
  top: 36px;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
  max-width: 600px;
  overflow: scroll;
  z-index: 2;
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: 127px;
  margin-top: -47px;
}

.toolbar .more .toggle-list-wrapper.toggle-up .item {
  background: #fff;
  line-height: 36px;
  width: 100%;
  margin: 0;
  padding: 0 19px;
  margin-left: 7px;
  font-size: 14px;
}

.toolbar .more .toggle-list-wrapper.toggle-up .item:hover {
  background-color: #f0f0f0;
}

.toolbar .more .toggle-list-wrapper.toggle-up .item.more {
  background-image: url(data:image/png;base64,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);
  width: 30px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: 18px -2px;
}

.toggle-list-wrapper.toggle-up.toggle-right {
  position: absolute;
  left: 230px !important;
  margin-top: -100%;
  padding: 20px 0px 20px 0px;
  min-width: 195px;
}
.group-actions .toolbar li.item.more .toggle-right {
  font-size: 20px;
}

/*Search Input */
.search {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  cursor: auto;
}

.search-icon {
  background-image: url(data:image/png;base64,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);
  background-size: 20px;
  overflow: hidden;
  display: block;
  width: 28px;
  height: 21px;
  float: left;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  margin-top: 0;
  cursor: pointer;
  margin-left: 0;
  position: relative;
  top: 3px;
}

.search input {
  border: 0;
  width: 0;
  margin-left: 5px;
  margin-top: 8px;
  cursor: initial;
  font-size: 18px;
  margin: 6px;
  -webkit-font-smoothing: antialiased;
  font-weight: 300;
  height: 100%;
  background: transparent;
  -webkit-transition: width 0.3s ease, border-color 0.3s ease;
  transition: width 0.3s ease, border-color 0.3s ease;
  outline: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.search.active {
  border-bottom: solid 2px rgb(255, 51, 102);
}

.search.active input {
  width: 230px;
}

.add-new-button-wrapper {
  position: relative;
  height: 140px;
  z-index: 1;
  width: 100%;
}

.add-new-button {
  text-align: center;
  display: block;
  cursor: pointer;
  color: white;
  border-radius: 6px;
  background-color: rgb(255, 51, 102);
  height: 60px;
  width: 114px;
  line-height: 59px;
  font-size: 23px;
  font-weight: 100;
  -webkit-box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  position: unset;
  top: 15px;
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
  float: right;
  margin-top: 45px;
}

.add-new-button i {
  color: white;
  font-size: 18px;
  opacity: 0.5;
  padding: 5px;
  padding-right: 0px;
  border: none;
}

.add-new-button i:hover {
  opacity: 1;
}

.add-new-button:hover {
  -webkit-transform: scale(1.1) rotate(0);
  transform: scale(1.1) rotate(0);
}
.add-new-button-wrapper .dropdown-list-open {
  position: absolute;
  right: 0;
  top: 115px;
  border-radius: 4px;
  z-index: 10;
  text-align: center;
  cursor: pointer;
}

.filter-item-wrapper {
  position: relative;
  background: #f9f9fb;
  width: 100%;
  display: flex !important;
  flex-wrap: wrap;
}

.filter-item-wrapper .filter-item {
  margin-right: 10px;
  background: #fff;
  margin-bottom: 10px;
}

.filter-item-wrapper .filter-item .filter.dropdown.edit {
  position: fixed;
  display: block;
  margin-top: 12px;
  margin-left: -16px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.filter-item-wrapper
  .filter-item
  .filter.dropdown.edit
  ::v-deep
  .dropdown
  .btn {
  width: fit-content;
}

.filter-item-wrapper .filter-item .filter.dropdown.edit input {
  border: 1px solid #9398a3;
  /* margin-top: 10px; */
  margin-left: 10px;
  margin-right: 10px;
  height: 26px;
  padding: 1px;
}

.item.filter-option.show-option {
  padding-bottom: 40px;
}

.key-filter select:focus {
  outline-width: 0;
}

.key-filter input:focus {
  outline-width: 0;
}

.key-filter .filter .tools i {
  font-size: 15px !important;
}

.filter-icon {
  background-image: url('../assets/img/filter.svg');
  background-size: 20px;
  overflow: hidden;
  display: block;
  width: 28px;
  height: 21px;
  float: left;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  cursor: pointer;
}

.filter.dropdown select,
input {
  border: none;
  display: inline-block;
  height: 36px;
  width: 119px;
  color: #000;
  font-size: 14px;
  text-align: center;
  padding: 6px 12px;
}

.filter.dropdown.edit select,
input {
  display: block;
  border-radius: 3px;
  text-align: left;
}

.filter.dropdown.add {
  top: 40px;
}
.filter.dropdown.add select,
input {
  display: inline-block;
}

.filter.dropdown.upload {
  width: 290px;
  padding: 39px;
  font-size: 14px;
  color: #4a556a;
  font-family: sans-serif;
  cursor: pointer;
  position: relative;
  margin-left: 0;
}

.filter-item-wrapper {
  margin-bottom: 10px;
  margin-top: 4px;
}

.filter-item {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  border: solid 1px #787d87;
  border-radius: 4px;
  padding: 6px 15px;
}

.filter-item i {
  opacity: 0;
  height: 5px;
  font-size: 11px;
  margin-left: 16px;
  color: #4f4f54;
}

.filter-item:hover {
  background-color: #f2f2f2;
}

.filter-item:hover i {
  opacity: 1;
}

.filter-item i.fa-caret-down {
  font-size: 15px;
  opacity: 1;
  width: 10px;
  margin-left: 16px;
}

.filter-item:hover i:hover {
  color: black;
}

.filter.dropdown {
  background-color: white;
  padding: 30px;
  -webkit-box-shadow: 0 6px 20px -2px rgb(0 0 0 / 20%);
  box-shadow: 0 6px 20px -2px rgb(0 0 0 / 20%);
  border-radius: 9px;
  position: absolute;
  z-index: 1;
}

.filter.dropdown hr {
  margin-top: 3px;
  background-color: #f0ebeb;
}

.filter.dropdown h2 {
  font-weight: 300;
  font-size: 22px;
  margin-bottom: 26px;
}

.filter.dropdown select {
  background: white;
}

/*for centered loader*/
.process-list {
  position: relative;
}

.progress-icon.dark-color.center:after {
  position: absolute;
  top: 0;
  left: 0;
  border: none;
}
.progress-icon.dark-color {
  left: 0;
  margin: 0 auto;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  border-radius: 9px;
  margin-top: 5px;
  box-sizing: border-box;
  padding: 20px;
  z-index: 3;
  cursor: pointer;
}
.group-list {
  display: block;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.group-list > span {
  display: block;
  padding: 8px 20px;
  background: #dfdfdf;
  border-radius: 4px;
  cursor: pointer;
}
.group-list.open > span i {
  transform: rotate(90deg);
}

.group-list > span i {
  margin-right: 20px;
  font-size: 16px;
  transition: all 300ms ease-in-out;
}
.group-list-wrapper {
  flex-wrap: wrap;
  padding: 15px;
  border: 1px solid #eee;
  display: none;
}
.group-list.open .group-list-wrapper {
  display: flex;
}
.add-new-button-wrapper .dropdown-list-open.unset-zIndex {
  z-index: 0;
}
p.message {
  position: absolute;
  right: 0;
  left: -10px;
  top: 35px;
  margin: 0 auto;
  display: block;
  color: green;
  font-size: 18px;
}

.embed {
  position: relative;
}
.action-top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.process-list-wrapper .code-tag-icon {
  zoom: 1.2;
}

::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}
</style>
